<template>
  <div v-if="show" class="success-modal-backdrop">
    <div class="success-modal-card">

      <!-- Ilustrasi -->
      <div class="success-image-wrapper">
        <img :src="imageSrc" alt="Pendaftaran berhasil">
      </div>

      <!-- Title -->
      <h2 class="success-title">
        Pendaftaran sebagai anggota
        <br />
        Partai Perindo berhasil.
      </h2>

      <!-- Subtitle -->
      <p class="success-text">
        Terima kasih telah mendaftarkan diri menjadi bagian dari Partai Perindo.
        Silahkan menggunakan fitur khusus anggota pada menu akun.
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'RegisterSuccessModal',
  props: {
    show: {
      type: Boolean,
      default: false
    },
    imageSrc: {
      type: String,
      default () {
        return require('../assets/images/reg-done.png')
      }
    },
  },
}
</script>

<style scoped lang="scss">
.success-modal-backdrop {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, .25);
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 1rem;
  z-index: 999;
}

.success-modal-card {
  background: #f5f5f7;
  border-radius: 10px;
  max-width: 600px;
  width: 100%;
  padding: 32px 32px 28px;
  box-shadow: 0 4px 30px rgba(0, 0, 0, .08);
  position: relative;
  text-align: center;
}

.success-close {
  position: absolute;
  right: 18px;
  top: 14px;
  border: none;
  background: transparent;
  font-size: 22px;
  cursor: pointer;
}

.success-image-wrapper {
  display: flex;
  justify-content: center;
  margin-bottom: 24px;

  img {
    max-width: 260px;
    width: 100%;
    height: auto;
  }
}

.success-title {
  font-size: 22px;
  line-height: 1.4;
  font-weight: 700;
  color: #1f3b82;
  margin-bottom: 12px;
}

.success-text {
  font-size: 14px;
  line-height: 1.6;
  color: #555;
  max-width: 520px;
  margin: 0 auto 24px auto;
}

.success-footer {
  display: flex;
  justify-content: center;
}

/* tombol sudah pakai class global .btn-fill.blue,
   tambah dikit biar kelihatan seperti di desain */
.btn-fill.blue {
  min-width: 220px;
}
</style>

